import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  getCourse,
  createLesson,
} from '../../../redux/actions/elearningActions';
import Modal from '../../../components/modal';
import { useParams, useNavigate } from 'react-router-dom';

type Props = {
  open: boolean;
  setOpen: Function;
  submit: Function;
};

const EditCourseModal = (props: Props) => {
  const { open, setOpen } = props;
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();

  const handleFormSubmit = async () => {
    const lessonId = await dispatch(
      createLesson(params.courseId, title, description)
    );
    await dispatch(getCourse(params.courseId));

    // Auto navigate to new lesson
    setTimeout(() => {
      navigate(`/courses/${params.courseId}/lessons/${lessonId}/update`);
    }, 1000);
    return true;
  };

  return (
    <Modal
      isOpen={open}
      setOpen={setOpen}
      showCancel={true}
      title={t('courses.create_module')}
      onConfirm={handleFormSubmit}
    >
      <form>
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            {t('courses.course_title')}
          </label>
          <input
            id="email"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder={t('courses.course_title')}
            required
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            {t('courses.description')}
          </label>
          <textarea
            id="password"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
            rows={8}
            placeholder={t('courses.describe_what_course_is_about')}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
      </form>
    </Modal>
  );
};

export default EditCourseModal;
